var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function getDefaultBlueprintRegistryClient() {
    const blueprintRegistry = [
        {
            id: 'cef15694-e331-4fd9-84c3-63c081f50259',
            name: 'Client Agreement Blueprint',
            dsl: `blueprint:
  name: Client Agreement Blueprint
  params:
    - name: template
      type: DocumentTemplate
      displayName: Document Template Param
      required: true
  spec:
    trigger: manualProspectAgreement
    actions:
      - call: sendTemplateForSignature
        name: sendTemplateForSignature_1
        args:
          template: !params template
          prospect: \${Context.Trigger.ProspectiveClient}
          roleName: signer1
      - call: convertProspectToClient
        name: convertProspectToClient_1
        args:
          prospect: \${Context.Trigger.ProspectiveClient}
      - call: uploadFromUrlToShareFile
        name: uploadFromUrlToShareFile_1
        args:
          file: \${sendTemplateForSignature_1.signedDocument}
          destinationFolderId: \${convertProspectToClient_1.clientFolderId}
`,
        },
    ];
    const handleBlueprintRegistryLookupById = (id) => __awaiter(this, void 0, void 0, function* () {
        return blueprintRegistry.find(r => r.id === id);
    });
    return {
        fetchBlueprintById: handleBlueprintRegistryLookupById,
    };
}
//# sourceMappingURL=defaultBlueprintRegistryClient.js.map